import { useEffect, useMemo, useState } from "react"
import FormBody from "./FormBody"
import FormHeader from "./FormHeader"
import { useDispatch, useSelector } from "react-redux"
import { Modal } from "antd"
import FormPreview from "./FormPreview"
import { spaceColorBgMapping } from "../../utils/colorBgColorMap"
import { getCurrentSpaceData } from "../../utils/currentUserDetail"

const FormContainer = (props) => {
    const { formHeader, nodeId, spaceId, widgetClickHandler, activeElement, formType, handleWidgetWidth, handleWidgetDelete, handleWidgetCopy, handleSectionReorder, conditions, previewMode, setPreviewMode, workflowSteps=[], passFormValues, defaultValues } = props
    const [showPreview, setShowPreview] = useState(false)
    const [currentStep, setCurrentStep] = useState({})

    const { userInfo, userGroupSpaces } = useSelector(state => state.user)
    // Returns a fresh object each call, and it is passed to every canvas field.
    const spaceData = useMemo(
        () => getCurrentSpaceData(spaceId, userInfo.spaceInfo, userGroupSpaces),
        [spaceId, userInfo.spaceInfo, userGroupSpaces]
    )

    useEffect(() => {
        if(workflowSteps.length > 0) {
            let stepWithCurrentForm = workflowSteps.find(step => step?.value === nodeId)
            setCurrentStep({...stepWithCurrentForm?.data, stepColor: stepWithCurrentForm?.data?.stepColor?.toUpperCase()})
        }
    },[workflowSteps])
    
    useEffect(() => {
        setShowPreview(previewMode)
    }, [previewMode])

    const handlePreviewClose = () => {
        setShowPreview(false)
        setPreviewMode(false)
    }

    return (
        <div className={`form-container bg-white ${!activeElement ? 'form-container-full' : ''}`} style={{ backgroundColor: spaceData?.spaceColor ? spaceColorBgMapping[spaceData.spaceColor] : "#f5eeff" }}>
            <FormHeader spaceData={spaceData} currentStep={currentStep} headerData={formHeader} formType={formType} widgetClickHandler={widgetClickHandler} activeElement={activeElement} />
            <FormBody currentStep={currentStep} workflowSteps={workflowSteps} formElements={props.formElements} activeElement={activeElement} activeDragItem={props.activeDragItem} widgetClickHandler={widgetClickHandler} formType={formType} handleWidgetWidth={handleWidgetWidth}
                handleWidgetDelete={handleWidgetDelete} handleWidgetCopy={handleWidgetCopy} handleSectionReorder={handleSectionReorder} spaceData={spaceData}
                passFormValues={passFormValues} defaultValues={defaultValues}
            />
            <Modal className="form-editor-preview" open={showPreview} onOk={handlePreviewClose} onCancel={handlePreviewClose} footer={false} destroyOnHidden>
                <FormPreview currentStep={currentStep} formElements={props.formElements} formType={formType} conditions={conditions} spaceData={spaceData} defaultValues={defaultValues} />
            </Modal>
            
        </div>
    )
}

export default FormContainer
